import React, { useEffect, useState } from "react";
import "../../assets/css/admin/AdminJobs.css";
import { getAdminJobs, updateJobStatus, bulkJobAction  } from "../../adminAPI/adminJobsApi";
import { formatRelativeDate, formatDateDDMMYYYY } from "../../utils/dateUtils";
import Pagination from "../../components/common/Pagination";

const JobsManagement = () => {
  const token = localStorage.getItem("otoken");

  const [jobs, setJobs] = useState([]);  
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    job_type: "",
    location: "",
  });
  //Bulk Action - Checkbox Logic
  const [selectedJobs, setSelectedJobs] = useState([]);

  // Pagination
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const PAGE_SIZE = Number(process.env.REACT_APP_TABLE_DEF_LENGTH);

  const loadJobs = async () => {
    const data = await getAdminJobs(
      { ...filters, page, limit: PAGE_SIZE },
      token
    );
    setJobs(data.jobs);
    setTotal(Number(data.total) || 0);
  };

  useEffect(() => {
    loadJobs();
  }, [page, filters]);

  const handleStatusChange = async (jobId, status) => {
    await updateJobStatus(jobId, status, token);
    loadJobs();
  };

  const handleFilterChange = (e) => {
  setFilters(prev => ({
    ...prev,
    [e.target.name]: e.target.value
  }));
  setPage(1);
};

const handleBulkAction = async (action) => {
  await bulkJobAction(action, selectedJobs, token);
  setSelectedJobs([]);
  loadJobs();
};

  return (
        <>
            <div className="page-header mb-3 pb-2 d-flex flex-wrap justify-content-between align-items-center" style={{ marginLeft: "30px", marginRight: "30px" }}>
            
                    <div className="mb-2 mb-md-0">
                        <h1 className="h4 mb-1">Jobs Management</h1>
                        <p className="text-muted mb-0">
                        Manage all job postings: review, approve, reject, archive and bulk update.
                        </p>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                        <button className="btn btn-sm btn-outline-secondary">
                        <i className="bi-download me-1"></i> Export
                        </button>
                        <button className="btn btn-sm btn-primary">
                        <i className="bi-plus-lg me-1"></i> Create Job
                        </button>
                    </div>
            </div>
        
            <div className="card shadow-sm mb-3" style={{ marginLeft: "30px", marginRight: "30px" }}>
                <div className="card-body">
                    <form className="row g-3 align-items-end filters-row" onSubmit={(e) => e.preventDefault()}>
                        <div className="col-md-3">
                            <label className="form-label small text-muted mb-1">Search</label>
                            <div className="input-group input-group-sm">
                                <span className="input-group-text bg-white border-end-0">
                                    <i className="bi-search"></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control border-start-0"
                                    placeholder="Job title, employer, ID..."
                                    name="search"
                                    value={filters.search}
                                    onChange={handleFilterChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted mb-1">Status</label>
                            <select 
                                className="form-select form-select-sm" 
                                name="status"
                                value={filters.status}
                                onChange={handleFilterChange}
                            >
                                <option value="">All</option>
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                                <option value="archived">Archived</option>
                                <option value="expired">Expired</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted mb-1">Job Type</label>
                            <select 
                                className="form-select form-select-sm"
                                name="job_type"
                                value={filters.job_type}
                                onChange={handleFilterChange}
                            >
                                <option value="">Any</option>
                                <option value="Full-Time">Full-time</option>
                                <option value="Part-Time">Part-time</option>
                                <option value="Contract">Contract</option>
                                <option value="Internship">Internship</option>
                                <option value="Freelance">Freelance</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted mb-1">Location</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="City or country"
                                name="location"
                                value={filters.location}
                                onChange={handleFilterChange}
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small text-muted mb-1">Date Range</label>
                            <select 
                                className="form-select form-select-sm"
                                name="date_range"
                                onChange={handleFilterChange}
                            >
                                <option value="">Any time</option>
                                <option value="today">Today</option>
                                <option value="7d">Last 7 days</option>
                                <option value="30d">Last 30 days</option>
                                <option value="90d">Last 90 days</option>
                            </select>
                        </div>
                        {/* <div className="col-md-1 d-flex gap-1">
                            <button type="submit" className="btn btn-sm btn-primary w-100">
                            Apply
                            </button>
                        </div> */}
                    </form>

                    {/* Active filters (chips) */}
                    {/* <div className="mt-3 d-flex flex-wrap align-items-center gap-2">
                        <span className="small text-muted me-1">Active filters:</span>
                        <span className="badge bg-light text-secondary border filter-chip">
                            Status: Pending
                            <i className="bi-x ms-1"></i>
                        </span>
                        <span className="badge bg-light text-secondary border filter-chip">
                            Type: Full-time
                            <i className="bi-x ms-1"></i>
                        </span>
                        <button className="btn btn-link btn-sm p-0 small">
                            Clear all
                        </button>
                    </div> */}
                </div>
            </div>
            
           	
            <div className="card shadow-sm" style={{ marginLeft: "30px", marginRight: "30px" }}>
                <div className="card-body border-bottom pb-2 d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
                        <div className="form-check mb-0">
                            <label className="form-check-label small" for="selectAllJobs">
                            Select all
                            </label>
                        </div>
                        <div className="dropdown">
                            <button
                                className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                disabled={selectedJobs.length === 0}
                            >
                                Bulk actions
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                <button className="dropdown-item" onClick={() => handleBulkAction("approve")}>
                                    Approve selected
                                </button>
                                </li>
                                <li>
                                <button className="dropdown-item" onClick={() => handleBulkAction("reject")}>
                                    Reject selected
                                </button>
                                </li>
                                <li>
                                <button className="dropdown-item" onClick={() => handleBulkAction("archive")}>
                                    Archive selected
                                </button>
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                <button
                                    className="dropdown-item text-danger"
                                    onClick={() => handleBulkAction("delete")}
                                >
                                    Delete selected
                                </button>
                                </li>
                            </ul>
                            </div>

                            <span className="small text-muted">
                            {selectedJobs.length} selected
                            </span>

                    </div>
                    
                    <div className="d-flex align-items-center gap-2">
                        <span className="small text-muted">Sort by:</span>
                        <select className="form-select form-select-sm w-auto">
                            <option value="created_desc">Newest</option>
                            <option value="created_asc">Oldest</option>
                            <option value="views_desc">Most views</option>
                            <option value="applications_desc">Most applications</option>
                        </select>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="jobs-table">
                        <thead>
                            <tr>
                            <th style={{width: "50px"}}>
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="selectAllJobs"
                                    style={{marginTop: "-5px", marginLeft: "8px"}}
                                    checked={jobs.length > 0 && selectedJobs.length === jobs.length}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                        setSelectedJobs(jobs.map(j => j.job_id));
                                        } else {
                                        setSelectedJobs([]);
                                        }
                                    }}
                                />
                            </th>
                            <th>Job</th>
                            <th>Employer</th>
                            <th>Location</th>
                            <th>Type</th>
                            <th>Applications</th>
                            <th>Status</th>
                            <th>Posted</th>
                            <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                    <tbody>
                        {jobs.map(job => (
                        <tr key={job.job_id}>
                            <td>
                                <input 
                                    className="form-check-input"
                                    style={{marginTop: "-5px", marginLeft: "8px"}} 
                                    type="checkbox"
                                    checked={selectedJobs.includes(job.job_id)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                        setSelectedJobs(prev => [...prev, job.job_id]);
                                        } else {
                                        setSelectedJobs(prev =>
                                            prev.filter(id => id !== job.job_id)
                                        );
                                        }
                                    }}
                                />
                            </td>                            
                            <td>
                                <strong>{job.title}</strong>
                                <div className="text-muted">Job ID: {job.job_code}</div>
                            </td>
                            <td>
                                <strong>{job.company_name}</strong>
                                <div className="text-muted">{job.employer_code}</div>
                            </td>
                            <td>
                                <div>{job.job_location}</div>
                                <small className="text-muted">{job.work_mode}</small>
                            </td>
                            <td>
                                <span >{job.job_type}</span>
                            </td>
                            <td>
                            <div>{job.total_applications}</div>
                            <small className="text-muted">
                                {job.shortlisted_applications} shortlisted
                            </small>
                            </td>
                            <td>
                                <span
                                    className={`badge ${
                                        job.status === "Deleted"
                                        ? "badge-deleted"
                                        : job.status.toLowerCase()
                                    }`}
                                >
                                    {job.status}
                                </span>

                            </td>
                            <td>
                                <div>{formatRelativeDate(job.created_at)}</div>
                                <small className="text-muted">
                                    {formatDateDDMMYYYY(job.created_at)}
                                </small>
                            </td>
                            <td>
                                <button
                                    className="btn btn-sm btn-outline-success me-1"
                                    onClick={() => handleStatusChange(job.job_id, "Approved")}>
                                     <i class="fa fa-solid fa-check"  tooltip="Verify" ></i>
                                </button>
                                <button 
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleStatusChange(job.job_id, "Deactivated")}>
                                    <i className="fa fas fa-times"></i>
                                </button>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>
                {/* <!-- Pagination --> */}
                <Pagination
                    page={page}
                    limit={PAGE_SIZE}
                    total={total}
                    label="Jobs"
                    onPageChange={setPage}
                />
            </div>
        </>        
  );
};

export default JobsManagement;